<template>
  <div>
    <component
      :is="comp"
      :entry="entry"
      :legalText="legalText"
      :legalTextParagraph="legalTextParagraph"
      @delete="$emit('delete', $event)"
      @close="$emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import type { IParagraphEntry } from "~/models/IUserEntry";
import type { ILegalText } from "~/models/ILegalText";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type { Component } from "vue";
import LinkChainContext from "./LinkChainContext.vue";
import MarkerContext from "./MarkerContext.vue";
import DeleteContextButton from "~/components/legaltextparagraph/contextmenu/DeleteContextButton.vue";

const props = defineProps<{
  entry: IParagraphEntry;
  legalText: ILegalText;
  legalTextParagraph: ILegalTextParagraph;
}>();

defineEmits<{
  close: [];
  delete: [entry: IParagraphEntry];
}>();

const CONTEXT_MAP: Record<IParagraphEntry["type"], Component> = {
  schema: DeleteContextButton,
  note: DeleteContextButton,
  link_chain: LinkChainContext,
  mark: MarkerContext,
  underline: DeleteContextButton,
};

const comp = computed(() => CONTEXT_MAP[props.entry.type]);
</script>
